<template>
  <layout-main-inner title="商品备案详情">
    <template slot="append">
      <span style="color:#888"
        v-if="userPermission.SUPERVISE || userPermission.OPERATE">({{productInfo.vendorName}})</span>
    </template>
    <el-form :model="productInfo"

      label-position='top'>
      <layout-card-wrap hasHeaderSlot
        v-loading="loading">
        <template slot="title">基本信息</template>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="商品名称:">
              <span>{{productInfo.productName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="名称备注:">
              <span>{{productInfo.productNameRemark}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品编号:">
              <span>{{productInfo.productNumber || ' '}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品类型:">
              <vendor-category-select style="width: 100%"
                status="detail"
                v-model="productInfo.categoryId"
                :option="{vendorId: productInfo.vendorId}" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="贸易类型:">
              <trade-radio-box v-model="productInfo.tradeType"
                status="detail"
                :option="{vendorId: productInfo.vendorId}" />
            </el-form-item>
          </el-col>
          <el-col :span="8"  v-if="!userPermission.SUPERVISE">
            <el-form-item label="标签类型:">
              <vendor-label-select :style="{width: productInfo.tagType === 5 ? 'auto' : '100%'}"
                v-model="productInfo.tagType"
                status="detail"
                :option="{vendorId: productInfo.vendorId}" />
              <el-tooltip v-if="productInfo.tagType === 5"
                effect="dark"
                :content="productInfo.productTagCodeScanUrl"
                placement="left-start">
                <!-- <i class="el-icon-tickets"></i> -->
                <copy-text :text="productInfo.productTagCodeScanUrl" />
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="8"
            v-if="productInfo.tagType !==5">
            <el-form-item label="赋码方式:">
              <coding-radio-box v-model="productInfo.codingType"
                status="detail"
                :option="{vendorId: productInfo.vendorId}" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8"
            v-if="productInfo.tradeType === 1">
            <el-form-item label="监管类别:">
              <el-tag v-if="productInfo.legalTest === 0">非法检</el-tag>
              <el-tag type="danger"
                v-if="productInfo.legalTest === 1">法检</el-tag>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item label="商品图片:">
              <upload-image v-model="productInfo.productImages"
                :limit="5"
                :autoCropWidth="300"
                :autoCropHeight="180"
                status="detail" />
            </el-form-item>
          </el-col>
        </el-row>
      </layout-card-wrap>
      <layout-card-wrap hasHeaderSlot
        style="margin-top:10px"
        v-loading="loading">
        <template slot="title">其他信息</template>
        <el-row :gutter="20">
          <template v-for="(item, index) in productInfo.baseFields">
            <el-col :span="item.type==='IMAGE' ? 24 : 8"
              :key="item.name">
              <smart-form :item="item"
                status="detail"
                :vendorId="productInfo.vendorId"
                :prop="'baseFields.' + index + '.fieldValue'" />
            </el-col>
          </template>
          <template v-for="(item, index) in productInfo.extraFields">
            <el-col :span="item.type==='IMAGE' ? 24 : 8"
              :key="item.name">
              <smart-form :item="item"
                status="detail"
                :vendorId="productInfo.vendorId"
                :prop="'extraFields.' + index + '.fieldValue'" />
            </el-col>
          </template>
        </el-row>
      </layout-card-wrap>
    </el-form>
    <template slot="footer">
      <back-button />
      <el-button type="primary"
        @click="edit"
        v-if="userPermission.ENT || userPermission.OPERATE"
        :loading="loading">编辑</el-button>
    </template>
  </layout-main-inner>
</template>
<script>
import TradeRadioBox from './busi/trade-radio-box.vue'
import CodingRadioBox from './busi/coding-radio-box.vue'
import VendorLabelSelect from './busi/vendor-label-select.vue'
import VendorCategorySelect from './busi/vendor-category-select.vue'
import UploadImage from '@/components/public/upload-image-new.vue'
import '@/components/business/custom-form/index'
import TemplateFormat from '@/utils/templateFormat'
import { mapState } from 'vuex'
import CopyText from '../../components/copy-text.vue'
export default {
  name: 'product-detail',
  components: { TradeRadioBox, CodingRadioBox, VendorLabelSelect, VendorCategorySelect, UploadImage, CopyText },
  data () {
    return {
      loading: false,
      productInfo: {}
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  methods: {
    getproduct (config) {
      this.loading = true
      this.$store.dispatch('product/getproduct', {
        payload: config,
        success: (res) => {
          this.loading = false
          res.data.productImages = res.data.productImages.split(',').map(item => ({ url: item }))
          res.data.baseFields = TemplateFormat.editTemplateFormat(res.data.baseFields)
          res.data.extraFields = TemplateFormat.editTemplateFormat(res.data.extraFields || [])
          this.productInfo = res.data
        },
        fail: () => {
          this.loading = false
          this.productInfo = {}
        }
      })
    },
    edit () {
      this.$router.push(`/product-update?vendorId=${this.$route.query.vendorId}&productId=${this.$route.query.productId}`)
    }
  },
  mounted () {
    this.getproduct({
      vendorId: this.$route.query.vendorId,
      productId: this.$route.query.productId
    })
  }
}
</script>
